import React, { FC, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { SignupWizardProvider, useSignupWizard } from './signup-wizard-context';
import StepCompany from './step-company';
import StepCategories from './step-categories';
import StepPlaces from './step-places';
import StepAboutYou from './step-about-you';
import StepInvite from './step-invite';
import StepVerify from './step-verify';
import StepAccountLinked from './step-account-linked';

// Step 6 branches on the Step 4 account check: an email that already exists in
// Aceve goes to the "Account linked" screen (no code), otherwise the email
// verification flow.
const StepSix: FC = () => {
  const { state } = useSignupWizard();
  return state.emailExists ? <StepAccountLinked /> : <StepVerify />;
};

const STEPS = [
  { path: '/supplier-sign-up', step: 1, component: StepCompany },
  { path: '/supplier-sign-up/categories', step: 2, component: StepCategories },
  { path: '/supplier-sign-up/places', step: 3, component: StepPlaces },
  { path: '/supplier-sign-up/about-you', step: 4, component: StepAboutYou },
  { path: '/supplier-sign-up/invite', step: 5, component: StepInvite },
  { path: '/supplier-sign-up/verify', step: 6, component: StepSix },
];

const WizardRoutes: FC = () => {
  const { isStepCompleted, trackEvent, withSource } = useSignupWizard();
  const location = useLocation();

  useEffect(() => {
    trackEvent('signup_wizard_started');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Synchronous navigation guard: redirect to earliest incomplete step (no flash)
  const currentStepConfig = STEPS.find(s => s.path === location.pathname);
  if (currentStepConfig && currentStepConfig.step > 1) {
    for (let i = 0; i < currentStepConfig.step - 1; i++) {
      if (!isStepCompleted(STEPS[i].step)) {
        return <Redirect to={withSource(STEPS[i].path)} />;
      }
    }
  }

  return (
    <Switch>
      {STEPS.map(({ path, component: Component }) => (
        <Route key={path} exact path={path} component={Component} />
      ))}
      <Redirect to={withSource('/supplier-sign-up')} />
    </Switch>
  );
};

const PageSupplierSignupWizard: FC = () => {
  return (
    <SignupWizardProvider>
      <WizardRoutes />
    </SignupWizardProvider>
  );
};

export default PageSupplierSignupWizard;
